import { useMemo } from "react";
import {
  List,
  TextField,
  DatagridConfigurable,
  NumberField,
  useTheme,
} from "react-admin";
import DownloadAction from "../../components/tableListActions/DownloadAction";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import costOfGoodsSoldFilterList from "../../components/costOfGoodsSolds/filter/costOfGoodsSoldFilterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, _] = getFirstAndLastDateOfCurrentMonth();

const CostOfGoodsSoldList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({ date: firstDate });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <List
        title="mine.label.cost_of_goods_sold"
        empty={false}
        actions={<DownloadAction />}
        filters={costOfGoodsSoldFilterList(permissions)}
        filterDefaultValues={filterDefaultValues}
      >
        <DatagridConfigurable
          // FIXME: semua datagrid perlu pake custom bulk action ini
          bulkActionButtons={false}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
          rowSx={(record) => {
            if (
              record.id === "inventory_available_for_sales" ||
              record.id === "cost_of_goods_sold"
            ) {
              return {
                "& .RaDatagrid-rowCell .MuiTypography-root": {
                  fontWeight: "900",
                  fontSize: "1rem",
                },
                "& .MuiTableCell-root .MuiTypography-root": {
                  fontWeight: "900",
                  fontSize: "1rem",
                },
              };
            }
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.company" />
          ) : null}
          <TextField source="name" label="mine.label.description" />
          <NumberField source="quantity" label="mine.label.quantity" />
          <NumberField source="amount" label="mine.label.amount" />
        </DatagridConfigurable>
      </List>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default CostOfGoodsSoldList;
